module.exports = __webpack_public_path__ + "static/media/Illus-Thanks@3x.dbd1952b.png";